// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select, selectAll } from 'd3-selection';
import { format } from 'd3-format';

import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
// import './utils/polyfills'; (includes Array.findIndex && Array.find)

// utils & data
import { stylePremium } from './utils/helpers';
import data from './data/data.json';


// styles
import './styles/graphic.scss';

const pkg = require('../package.json');


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  const { pymChild } = window;

  if (pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl);
  }

  pymChild.sendHeight();
};

const CNNPolitics = true;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw(initialWidth) {
  const safeWidth = document.querySelector('.graphic').clientWidth;
  const isMobile = (safeWidth || initialWidth) < 500;

  const table = select('#graphic')
    .html('')
    .append('table');

  table.html('');

  const keys = Object.keys(data[0]);
  const comma = format(',');

  const thead = table.append('thead');
  const tbody = table.append('tbody');

  const th = thead.append('tr')
    .selectAll('th')
    .data(keys)
    .enter()
    .append('th')
    .attr('aria-role', 'columnheader')
    .style('text-align', (d, i) => (i === keys.length - 1 && !isMobile ? 'right' : null))
    .html((d, i) => `<span class='header ${i === keys.length - 1 && !isMobile ? 'right' : ''}'>
					${d.toLowerCase()}
				</span>
				<span class='sorter ${i === keys.length - 1 && !isMobile ? 'right' : i === 0 ? 'ascending' : ''}'>
				</span>`);

  const tr = tbody.selectAll('tr')
    .data(data)
    .enter().append('tr')
    .attr('aria-role', 'row')
    .attr('class', d => ((d.reversal === 'Yes') ? 'reversed' : 'normal'))
    .html(d => keys.map((key, index) => `<td ${index === keys.length - 1 && !isMobile ? 'style=\'text-align:right;\'' : ''} aria-role='cell'>
              
              ${key === 'reversal' && isMobile ? `Reversal: ${d[key]}` : d[key]}
						</td>`)
      .join(''));

  th.on('click', (d, i, el) => {
    // sorting function
    const that = select(el[i]);
    const sorter = that.select('.sorter');
    const header = that.select('.header');
    const ascending = sorter.classed('ascending');
    const key = header.text().replace(/\s/g, '');

    selectAll('.sorter')
      .classed('ascending descending', false);

    sorter.classed('ascending', !ascending);
    sorter.classed('descending', ascending);

    tr.sort((a, b) => (ascending // sorted ascended, so sort descended
      ? (a[key] < b[key] ? 1 : a[key] === b[key] ? 0 : -1)
      : (a[key] < b[key] ? -1 : a[key] === b[key] ? 0 : 1)));
  });
}
